// @flow

import * as React from 'react';
import { get } from 'lodash';
import classnames from 'classnames';
import bookingUtils from 'Utils/ple-utils/bookingUtils';

import DurationTravelDetails from './duration/DurationTravelDetails.jsx';
import ParticipantsTravelDetails from './participants/ParticipantsTravelDetails.jsx';
import TransportTravelDetails from './transport/TransportTravelDetails.jsx';

type Props = {
  +config: {
    +memberSpace: *,
  },
  stay: Stay,
  vendor?: BookingVendor,
  bookingStatus: BookingStatus,
  isVertical?: boolean,
};

function propsForTransportTravelDetails(config, vendor, bookingStatus, stay = {}) {
  return {
    departureCity: stay.departureCity,
    arrivalCity: stay.arrivalCity,
    returnDate: stay.returnDate,
    bookingStatus: bookingStatus,
    isJoyview: get(stay, 'resort.isJoyview'),
    vendor: vendor,
    travelAdvisor: get(config, 'travelAdvisor'),
    labels: {
      transport: get(config, 'memberSpace.trips.transport'),
      withoutTransport: get(config, 'booking.form.withoutTransport'),
      dedicatedJoyviewHotlineNumber: get(config, 'memberSpace.trips.dedicatedJoyviewHotlineNumber'),
    },
    transportType: get(stay, 'transportType'),
  };
}

export default function TravelDetails({ config, stay, vendor, bookingStatus, isVertical }: Props) {
  const cmsContent = get(config, 'memberSpace', null);
  const isJoyview = get(stay, 'resort.isJoyview');
  const isArchived = bookingUtils.isArchived(bookingStatus);

  return cmsContent && stay ? (
    <div
      className={classnames('TravelDetails', {
        isVertical: Boolean(isVertical),
      })}
    >
      <DurationTravelDetails
        departureDate={get(stay, 'departureDate')}
        returnDate={get(stay, 'returnDate')}
        dateFormat={get(config, 'memberSpace.trips.duration.dateFormat')}
        fromLabel={get(config, 'memberSpace.trips.duration.from')}
        toLabel={get(config, 'memberSpace.trips.duration.to')}
      />
      {!isArchived && (
        <ParticipantsTravelDetails
          adults={{
            number: get(stay, 'adults', 0),
            labels: get(config, 'memberSpace.trips.adults', {}),
          }}
          children={{
            number: get(stay, 'children', 0),
            labels: get(config, 'memberSpace.trips.children', {}),
          }}
        />
      )}
      {!isJoyview && (
        <TransportTravelDetails
          {...propsForTransportTravelDetails(config, vendor, bookingStatus, stay)}
        />
      )}
    </div>
  ) : null;
}
